import React, {useState} from "react";
import {isMobile} from "../../../../helpers/Mobile"
import styles from "./MainApp.organisms.TogglePanel.module.scss";


export const TogglePanel = ({fields, title=i18n.t("description")}) => {
    const [ toggleOpen, setToggleOpen ] = useState(false)

    return (
        <div className={styles["toggle-panel-container"]}>

            <div className={styles["toggle-panel-title"]} onClick={() => setToggleOpen(!toggleOpen)}>
            {title}
                {(isMobile) &&
                    <i
                        name="icon-chevron"
                        className={`${styles["icon-chevron"]} ${styles["toggle-panel-chevron"]} ${toggleOpen ? styles["open"] : ""}`}
                    ></i>
                }
            </div>

                {(!isMobile || toggleOpen) && <React.Fragment>
                    {fields.map( item => {
                        return (<div className={styles["toggle-panel-section"]} key={item.title}>
                                    <div className={styles["toggle-panel-section-title"]}>{item.title}</div>
                                    <div className={styles["toggle-panel-section-content"]}>{item.value}</div>
                                </div>)
                    })}
                </React.Fragment>}

        </div>
    );

}

export default TogglePanel;